<template>
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M3.29993 3.29925C5.32488 1.2743 8.6765 1.2743 10.7014 3.29925L9.09543 4.90525H13.285V0.715722L11.9583 2.0424C9.23509 -0.680799 4.76627 -0.680799 2.04307 2.0424C0.506923 3.57855 -0.121507 5.67331 0.0879697 7.69826H1.8336C1.62412 6.16211 2.11289 4.4863 3.29993 3.29925Z"
        fill="currentColor"/>
    <path
        d="M13.9138 6.30176H12.1682C12.3776 7.83791 11.8889 9.51372 10.7018 10.7008C8.67687 12.7257 5.32525 12.7257 3.30033 10.7008L4.90633 9.09477H0.716797V13.2843L2.04347 11.9576C4.76666 14.6808 9.16567 14.6808 11.8889 11.9576C13.4948 10.4215 14.1233 8.32671 13.9138 6.30176Z"
        fill="currentColor"/>
  </svg>

</template>

<script>
export default {
  name: "IconReset"
}
</script>